/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'
import { List } from 'immutable'
import { AccommodationInvoiceDetailState } from '../state/AccommodationInvoiceDetailState'

class AccommodationInvoiceDetailsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccommodationInvoiceEvent.fetchOne:
        if (!payload || !payload.invoice_details) {
          return state
        }

        const details = payload.invoice_details.map(detail => new AccommodationInvoiceDetailState(detail))
        return List(details)

      default:
        return state
    }
  }
}

export default new AccommodationInvoiceDetailsStore()
